import Vue from 'vue'
import Vuex from 'vuex'
import http from '../../httpuntil'

Vue.use(Vuex)

/*
页面通过mapaction 异步提交到事件 actions，actions通过commit把对应参数同步mutation，mutation会修改state对应的值，最后通过getter把对应的值抛出去，在页面计算属性中，通过mapgetter获取state
*/

const state = {
    projects: [],
    project: {},
    // projectFilter: { CategoryID: { Value: null }, Name: { Value: null }, Pager: { PageNumber: 1, PageSize: 20 }, CreateTime: { Sort: 1 } },
    categories: [],
    recommendProjects:[]

}

const getters = {
    // projects: state => {
    //     return state.projects;
    // },
    // categorys: state => {
    //     return state.categories;
    // }
}

const actions = {
    setprojucts({commit},val) {
       
        commit('setProjucts',val)
    },
    getProjects({ commit }, filter) {
        
        
        var filtersval= JSON.parse(JSON.stringify(filter));
       
        if(filter.Category.Value==0) {
            
            filtersval.Category={
                Value:null
            }
        }
        
        //state.projectFilter.CategoryID.Value = categoryID;
        http.post("/api/project/list", filtersval, (data) => {
            if (data.Success) {
                //处理精选
                // if(filter.Category.Value==0) {
                //     var recommarr=[]
                //     data.Data.Results.forEach(function(val,ind) {
                //         if(val.IsRecommend) {
                //             recommarr.push(val)
                //         }
                //     })
                //     data.Data.Results = recommarr
                // }
                
              
                if(filtersval.Address.Value==null && filtersval.Name.Value==null &&  filtersval.Pager.PageNumber!=1) {
                   
                    var statepro = JSON.parse(JSON.stringify(state.projects))
                
                   data.Data.Results.forEach(function(vals,inds) {
                        statepro.Results.push(vals)
                    })
                   
                    data.Data.Results = statepro.Results
                  
                }
                
                  commit('setprojectListData', data.Data);
                
            }
        }, (e) => {
            console.log(e);
        });
    },
    getRecommendProjects ({ commit}, filter) {
        
        http.post("/api/project/list",filter,(data)=>{
        if (data.Success) {
            commit('setRecommendProjects',data.Data);
        }
        },(e)=>{
        console.log(e);
        });
    },
    getProject({ commit }, id) {
        http.get("/api/project/detail/" + id, (data) => {
            if (data.Success) {
                commit('setProject', data.Data);
            }
        }, (e) => {
            console.log(e);
        });
    },
    getAllCategory: function ({ commit }) {
        http.get("/api/project/category", (data) => {
            if (data.Success) {
                var categories = [{ DisplayName: '精选', Value: 0 }];
                var catearrdata = categories.concat(data.Data)
                catearrdata.push({ DisplayName: '预告', Value: 'isStart'})
                commit('setCategory', catearrdata);
                //commit('setSelectedCategoryID',0);
            }
        }, (e) => {
            console.log("获取分类错误：" + e);
        });
    },
}

const mutations = {
    setProjucts (state, projucts) {
     
     state.projects = projucts
    },
    setprojectListData(state, data) {
        state.projects = data;
    },
    setProject(state, data) {
        state.project = data;
    },
    setRecommendProjects (state, projects) {
        state.recommendProjects = projects
    },
    setprojectFilterIsRecommend(isrecommend) {
        if (isrecommend == 0) {
            state.projectFilter.IsRecommend = null;
        } else {
            state.projectFilter.IsRecommend = { "Value": true };
        }
    },
    setCategory(state, categories) {
        state.categories = categories
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
